// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__110Pz","large":"styles_large__2QJaQ"};